import { t } from 'i18next';
import * as yup from 'yup';

const jobSchema = () =>
  yup.object().shape({
    id: yup.string().nullable(),
    name: yup.string().nullable().label(t('labelJobName')).required(),
    details: yup
      .string()
      .nullable()
      .label(t('labelJobDescription'))
      .max(1200)
      .required(),
    disciplineId: yup.string().nullable(),
    disciplineName: yup.string().nullable().required(),
    attachaments: yup.mixed().nullable(),
  });

export const requestJobsDetailsSchema = () =>
  yup.object().shape({
    jobs: yup
      .array()
      .of(jobSchema())
      .label(t('labelJobs'))
      .min(1, t('errorDisciplineRequired'))
      .required(),
  });
